import { FunctionComponent } from 'react';
import { Modal, Image} from 'react-bootstrap';
import cn from 'classnames';
import styles from "./NudgeSponsoredUser.module.css";
import CustomButton, { ButtonRadiusSize, ButtonType } from '../../../../../component/common/CustomButton/CustomButton';
import { ASSESTS } from '../../../../../constant/assest';
import FormTextArea from '../../../../../component/common/FormField/FormTextArea';
import FormField, { IFieldTheme, IFieldType } from '../../../../../component/common/FormField/FormField';


interface IProps {
    showModal: boolean;
    onClose: () => void;
    className?: string;
};

const NudgeSponsoredUser: FunctionComponent<IProps> = ({showModal, onClose, className}) => {
  return (
    <Modal 
        show={showModal} 
        className={cn(styles.addModal, className)}
        dialogClassName={styles.addModalDialog}
        contentClassName={styles.addModalContent}
        centered={true}
    >
        <CustomButton
            className={styles.modalCloseBtn}
            btnType={ButtonType.IMAGE}
            onClick={onClose}
        >
            <Image src={ASSESTS.CLOSEPOPUP}  alt="Close" />
        </CustomButton>
        <Modal.Header bsPrefix={styles.header}>
          <Modal.Title bsPrefix={styles.title} as={'div'}>Nudge Sponsored User</Modal.Title>
        </Modal.Header>
        <Modal.Body bsPrefix={styles.body}>
            <FormField
                label={'Email Address'}
                placeholder='John@email.com'
                fieldTheme={IFieldTheme.LIGHT2} 
                fieldType={IFieldType.EMAIL}
            />
            <FormTextArea
                className={styles.textArea}
                fieldTheme={IFieldTheme.LIGHT2}
                label={'Promotional Script'}
                placeholder="Hi, (Angler’s name) We hope all is well on your end. We've noticed it\'s been a while since your last post, and just wanted to check in."
            />
        </Modal.Body>
        <Modal.Footer bsPrefix={styles.footer}>
            <CustomButton
                className={styles.addMoreBtn}
                btnType={ButtonType.LIGHTBLUE}
                btnRadius={ButtonRadiusSize.SMALL}
                onClick={onClose}
            >
                Cancel
            </CustomButton>
            <CustomButton
                className={styles.addBtn}
                btnType={ButtonType.GREEN}
                btnRadius={ButtonRadiusSize.SMALL}
            >
                Send Message
            </CustomButton>
        </Modal.Footer>
    </Modal>
  );
}

export default NudgeSponsoredUser;